/**
 * Website "Increase engagement": scrollable tab nav with arrows + fading panes.
 */
jQuery(function ($) {
    var $navWrapper = $('.increase-engagement-section .increase-engagement-nav-wrapper');
    var $navContainer = $('.increase-engagement-section .engagement-tabs-nav');
    if (!$navContainer.length) return;

    function updateArrowVisibility() {
        var scrollLeft = $navContainer.scrollLeft();
        var maxScroll = $navContainer[0].scrollWidth - $navContainer.outerWidth();

        if (maxScroll > 5) {
            $navWrapper.addClass('has-scroll');
            $navWrapper.find('.engagement-nav-arrow--left').toggle(scrollLeft > 5);
            $navWrapper.find('.engagement-nav-arrow--right').toggle(scrollLeft < maxScroll - 5);
        } else {
            $navWrapper.removeClass('has-scroll');
            $navWrapper.find('.engagement-nav-arrow').hide();
        }
    }

    $navContainer.on('scroll', updateArrowVisibility);
    $(window).on('resize', updateArrowVisibility);
    updateArrowVisibility();
    setTimeout(updateArrowVisibility, 150);

    $navWrapper.find('.engagement-nav-arrow--left').on('click', function (e) {
        e.preventDefault();
        $navContainer.animate({ scrollLeft: '-=250' }, 300, updateArrowVisibility);
    });

    $navWrapper.find('.engagement-nav-arrow--right').on('click', function (e) {
        e.preventDefault();
        $navContainer.animate({ scrollLeft: '+=250' }, 300, updateArrowVisibility);
    });

    $('.increase-engagement-section .engagement-tab-btn').off('click').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        var $section = $(this).closest('.increase-engagement-section');

        $section.find('.engagement-tab-btn').removeClass('active');
        $section.find('.engagement-pane').removeClass('active').hide();

        $(this).addClass('active');

        // Scroll active tab into view if overflowing
        var btn = this;
        var container = $navContainer[0];
        var btnLeft = btn.offsetLeft;
        var btnRight = btnLeft + btn.offsetWidth;
        var containerLeft = container.scrollLeft;
        var containerRight = containerLeft + container.offsetWidth;

        if (btnLeft < containerLeft) {
            $navContainer.animate({ scrollLeft: btnLeft - 20 }, 200, updateArrowVisibility);
        } else if (btnRight > containerRight) {
            $navContainer.animate({ scrollLeft: btnRight - container.offsetWidth + 20 }, 200, updateArrowVisibility);
        }

        $section.find(target).addClass('active').fadeIn(300, function () {
            $(window).trigger('resize');
        });
    });
});
